module.exports = __webpack_public_path__ + "img/giro.9a3a6208.png";